import { useState } from "react";
import { ArrowRight, Eye, EyeOff, LoaderCircle, LockKeyhole } from "lucide-react";
import { motion } from "framer-motion";
import { loginInvestor } from "./investorApi";

export const InvestorAccessGate = ({ onAuthenticated }) => {
  const [code, setCode] = useState("");
  const [show, setShow] = useState(false);
  const [working, setWorking] = useState(false);
  const [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault(); setWorking(true); setError("");
    try { await loginInvestor(code); await onAuthenticated(); }
    catch (requestError) { setError(requestError.message); }
    finally { setWorking(false); }
  };
  return (
    <main className="invest-access" data-testid="invest-access-gate">
      <div className="invest-access-image" aria-hidden="true" />
      <div className="invest-access-grid" aria-hidden="true" />
      <motion.section initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}>
        <div className="invest-access-brand"><img src="/brand/humn-wordmark.png" alt="HUMN" /><span>PRIVATE INVESTOR EXPERIENCE</span></div>
        <p><LockKeyhole size={14} /> CONTROLLED ACCESS</p>
        <h1>Enter the<br /><em>Intention Network.</em></h1>
        <span>This material is intended only for invited investors and authorised recipients.</span>
        <form onSubmit={submit}>
          <label htmlFor="invest-access-code">Investor access code</label>
          <div><input id="invest-access-code" type={show ? "text" : "password"} value={code} onChange={(event) => setCode(event.target.value)} autoComplete="current-password" required data-testid="invest-access-code-input" /><button type="button" onClick={() => setShow((value) => !value)} aria-label={show ? "Hide access code" : "Show access code"} data-testid="invest-access-code-visibility-button">{show ? <EyeOff size={17} /> : <Eye size={17} />}</button></div>
          <button type="submit" disabled={working || code.length < 6} data-testid="invest-access-submit-button">{working ? <LoaderCircle className="animate-spin" /> : <ArrowRight />} {working ? "VERIFYING" : "ENTER HUMN"}</button>
        </form>
        {error && <div className="invest-access-error" role="alert" data-testid="invest-access-error">{error}</div>}
        <small>12-hour private session · No investor material is loaded before verification.</small>
      </motion.section>
    </main>
  );
};